export default __webpack_public_path__ + "static/media/ic-crops-root-vege.33b0e125.svg";